export const singlePhaseTabs = [
  { name: 'Basic Info', link: 'basic-info' },
  { name: 'Team', link: 'team' },
  { name: 'Documents', link: 'documents' },
  { name: 'Tasks', link: 'tasks' },
  { name: 'Forms', link: 'forms' },
  //  TODO: reuse after implementation
  // { name: 'Reports', link: 'reports' },
  { name: 'Workflows', link: 'workflows' },
  // { name: 'Analytics', link: 'analytics' },
];
